module.exports = __webpack_public_path__ + "img/4_4.f96a7df3.png";